import { useEffect } from "react";

/* A page that knows a better title than config/pageTitles.js gives its route,
   such as a lesson's own name, sets it with usePageTitle(title) while it is
   mounted. RouteAnnouncer uses it for the browser tab and the announcement. */

let current = null;
const listeners = new Set();

const setCurrent = (title) => {
  current = title;
  listeners.forEach((listener) => listener());
};

export const subscribePageTitle = (listener) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

// The title a mounted page has set, or null.
export const getPageTitle = () => current;

export function usePageTitle(title) {
  useEffect(() => {
    if (!title) return undefined;
    setCurrent(title);
    return () => {
      if (current === title) setCurrent(null);
    };
  }, [title]);
}
